import { Nullable } from '@/shared/lib';

export type FileInfo = {
  name?: string;
  type?: string;
}

export const getFileInfo = (file?: Nullable<string>): Nullable<FileInfo> => {
  const filename = file?.split(/(\\|\/)/g)?.pop();

  if (!filename) return null;

  const dotIndex = filename.lastIndexOf('.');

  return {
    name: filename.substring(0, dotIndex),
    type: filename.substring(dotIndex + 1),
  };
};
